<template>
  <header>
    <div class="header-content-wrapper px-8 px-md-16">
      <div class="d-flex align-center mt-1 mt-md-0">
        <img
          src="@/assets/LyricsterLogo.png"
          style="cursor: pointer"
          class="header-logo mr-4"
          @click="$router.push('/dashboard')"
        />
        <div v-if="authUser && authUser.id" class="search-bar" id="search-bar">
          <v-text-field
            dark
            solo
            flat
            placeholder="Quick search type, genre, location…"
            class="header-field ma-0"
            hide-details
            v-model="query"
          >
          </v-text-field>

          <v-btn
            class="ma-0 white--text primary search-icon"
            @click="lc_search"
          >
            Search Network
          </v-btn>
        </div>
      </div>
      <div
        v-if="authUser && authUser.id"
        class="ml-auto center"
        id="navigation"
      >
        <div class="d-flex align-center" style="cursor: pointer">
          <div class="nav-link toggler" @click="collapse = !collapse">
            <i class="fa fa-bars"> </i>
          </div>
          <div class="collapse" :class="{ show: collapse }">
            <router-link
              class="nav-link text-decoration-none top-link"
              to="/dashboard"
              title="Home"
            >
              <i class="fa fa-home"></i>
              <div class="link-text d-inline d-sm-none ml-3">Home</div>
            </router-link>
            <router-link
              class="nav-link text-decoration-none top-link ml-4"
              to="/featured"
              title="Featured"
            >
              <i class="fa fa-trophy"></i>
              <div class="link-text d-inline d-sm-none ml-3">Featured</div>
            </router-link>
            <router-link
              class="nav-link text-decoration-none top-link ml-4"
              to="/music-room"
              title="Music Room"
            >
              <i class="fa fa-music"></i>
              <div class="link-text d-inline d-sm-none ml-3">Music Room</div>
            </router-link>
            <router-link
              class="nav-link text-decoration-none top-link ml-4"
              to="/network"
              title="Network"
            >
              <i class="fa fa-globe"></i>
              <div class="link-text d-inline d-sm-none ml-3">Network</div>
            </router-link>
            <router-link
              class="nav-link text-decoration-none top-link ml-4"
              to="/messages"
              title="Messages"
            >
              <i class="fa fa-envelope"></i>
              <div class="link-text d-inline d-sm-none ml-3">Messages</div>
            </router-link>

            <div class="search-bar">
              <v-text-field
                dark
                solo
                flat
                placeholder="Quick search type, genre, location…"
                class="header-field ma-0"
                hide-details
                v-model="query"
              ></v-text-field>
              <v-btn
                class="ma-0 white--text primary search-icon"
                @click="lc_search"
              >
                Search Network
              </v-btn>
            </div>
          </div>
          <div
            class="
              d-inline-block
              nav-link
              text-decoration-none
              ml-4
              bell-parent
            "
            id="bell"
          >
            <i
              @click="
                showNotifications = !showNotifications;
                readNotifications(authUser.id);
              "
              class="fa fa-bell"
            ></i>
            <div
              class="bell-dropdown"
              id="bell-dropdown"
              v-if="notifications.length != 0"
              :class="{ show: showNotifications }"
            >
              <notification
                v-for="notification of notifications"
                :key="notification.id"
                :item="notification"
              />
              <v-btn block to="/notifications">See all</v-btn>
            </div>
            <div
              style="
                position: absolute;
                top: -8px;
                right: -8px;
                padding: 5px;
                height: 20px;
                width: 20px;
                font-size: 10px;
                border-radius: 50%;
              "
              v-if="
                notifications.filter((notification) => !notification.isRead)
                  .length != 0
              "
              class="red d-flex align-center justify-center"
            >
              {{
                notifications.filter((notification) => !notification.isRead)
                  .length
              }}
            </div>
          </div>
          <v-menu>
            <template v-slot:activator="{ on, attrs }">
              <v-avatar
                v-if="authUser.profile_image"
                v-bind="attrs"
                v-on="on"
                class="ml-4"
                size="40"
                ><img :src="authUser.profile_image"
              /></v-avatar>
              <v-avatar v-else v-bind="attrs" v-on="on" class="ml-4" size="40"
                ><img src="/images/default-profile.jpg"
              /></v-avatar>
            </template>
            <v-list class="width-200" id="user-dropdown">
              <v-list-item>
                <div class="d-flex align-center pa-3">
                  <v-avatar v-if="authUser.profile_image" size="38"
                    ><img :src="authUser.profile_image"
                  /></v-avatar>
                  <v-avatar v-else size="38"
                    ><img src="/images/default-profile.jpg"
                  /></v-avatar>
                  <div class="mx-3">
                    <h4 class="ma-0">
                      {{ authUser.firstname }} {{ authUser.lastname }}
                    </h4>
                    <v-chip x-small class="ma-0" color="green white--text"
                      >Paid Tier</v-chip
                    >
                  </div>
                </div>
              </v-list-item>
              <v-divider />
              <v-list-item>
                <v-list-item-title @click="$router.push('/profile')"
                  >Account Info</v-list-item-title
                >
              </v-list-item>
              <v-list-item>
                <v-list-item-title @click="logout">Logout</v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
        </div>
      </div>
    </div>
  </header>
</template>

<script>
import Notification from "../Notification/Notification.vue";
export default {
  components: { Notification },
  name: "Header",
  data() {
    return {
      collapse: false,
      showNotifications: false,
      query: "",
    };
  },
  methods: {
    lc_search() {
      this.getSearchedData({ query: this.query, user_id: this.authUser.id });
      this.$router.push("/search");
    },
  },
  mounted() {
    let bell = document.getElementById("bell");
    document.addEventListener("click", (e) => {
      console.log(bell.contains(e.target));
      if (!bell.contains(e.target)) {
        this.showNotifications = false;
      }
    });
  },
};
</script>
<style scoped>
.width-200 {
  width: 200px;
}
.bell-parent {
  position: relative;
}
.bell-dropdown {
  display: none;
  width: 320px;
  border: 1px solid rgba(0, 0, 0, 0.2);
  background: white;
  position: absolute !important;
  top: 40px;
  z-index: 8;
  right: 0;
  max-height: 480px;
  overflow-y: auto;
}
.bell-dropdown.show {
  display: block;
}
.header-logo {
  height: 45px;
}
.search-bar {
  position: relative;
  width: 450px;
}
.search-icon {
  position: absolute;
  cursor: pointer;
  color: #fff;
  top: 50%;
  right: 10px;
  transform: translateY(-50%);
}
.header-field {
  width: 100%;
  text-overflow: ellipsis;
}
.header-content-wrapper {
  height: 60px;
  width: 100%;
  display: flex;
  align-items: center;
  position: relative;
}
.header-content-wrapper div {
  position: relative;
}
.nav-link {
  color: #ffffff;
}
.top-link:hover {
  transform: scale(1.2, 1.2) !important;
}
.top-link:hover i {
  font-size: 24px;
}
.top-link:hover .link-text {
  display: inline-block !important;
}
header {
  background: #000000 !important;
  display: flex;
  align-items: center;
}
.toggler {
  display: none !important;
}
.collapse .search-bar {
  display: none;
}
@media (min-width: 767.98px) and (max-width: 959.98px) {
  header {
    height: 120px;
  }
  .header-content-wrapper {
    flex-direction: column;
    justify-content: center;
  }
  .center {
    margin: 0 auto !important;
  }
  .center > div {
    margin-top: 10px;
    justify-content: center;
  }
}
@media (max-width: 767.98px) {
  .header-content-wrapper .d-sm-none {
    display: inline-block !important;
  }
  .search-bar {
    display: none;
    width: 100%;
    max-width: 100%;
  }
  .collapse:not(.show) {
    display: none;
  }
  .toggler {
    display: block !important;
  }
  .collapse .search-bar {
    display: block;
  }
  .collapse .header-field {
    display: block;
    max-width: 100% !important;
    margin: 10px 20px !important;
  }
  .collapse .search-icon {
    right: 40px;
  }
  .collapse.show {
    position: absolute;
    top: 100%;
    left: 0;
    width: 100%;
    background: #1d2f38;
    display: block;
    z-index: 9;
  }
  .collapse.show .nav-link {
    display: block;
    margin-left: 0px !important;
    padding: 10px 20px;
    opacity: 0.6;
  }
  .collapse.show .nav-link:hover {
    opacity: 1;
  }
}
</style>
